import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import agronomistSliceReducer from "./feature/agronomistSlice";
import growerSliceReducer from "./feature/growerSlice";
import scoutingActiveTabSlice from "./feature/scoutingActiveTabSlice";

const rootReducer = combineReducers({
  agronomist: agronomistSliceReducer,
  grower: growerSliceReducer,
  scoutingActiveTab: scoutingActiveTabSlice,
});
const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
});

export const persister = persistStore(store);
